import { Units } from '@turf/turf';

export const unitsDegrees = { units: 'degrees' as Units };
export const unitsMiles = { units: 'miles' as Units };
